<template>
    <transition name="fade">
        <v-flex md12 v-show="visibility">
            <BnHelpField :name="mezo" :active="help">

                <span v-if="forgalmiBetukod !== null" slot="one" class="forgalmi-prefix"> {{ forgalmiBetukod }} </span>
                <component
                    slot="two"
                    @focus="focus()"
                    :label="label"
                    :is="getInputType"
                    :items="getOptions"
                    :item-text="itemsText"
                    :item-value="itemsValue"
                    :disabled="!editable"
                    v-model="inputVal"
                    :mask="mask"
                    :rules="rules"
                    validate-on-blur
                    :hint="getPersistentHint"
                    persistent-hint
                    clearable
                    :counter="counter"
                    :path="path"
                    :suffix="suffix"
                    @blur="blurFn()"
                    @change="changeFn()"
                    :prefix="prefix"
                    :ref="mezo"
                > </component>
            </BnHelpField>
        </v-flex>
    </transition>
</template>
<script>

import { mapActions } from 'vuex';
import Vue from 'vue';
import storeValueByPath from '../../mixins/StoreValueByPath';

export default {

    inheritAttrs: false,

    mixins: [storeValueByPath],

    data() {
        return {
            visibility: false,
        };
    },

    props: {
        path: {
            type: String,
            required: true,
        },
        help: {
            default: true,
            type: Boolean,
        },
        label: {
            type: String,
        },
        type: {
            type: String,
            required: true,
        },
        options: {
            type: Array,
        },
        editable: {
            type: Boolean,
            required: true,
        },
        visible: {
            type: Boolean,
            required: true,
        },
        mezo: {
            type: String,
        },
        objKey: {
            type: String,
        },
        mask: {
            type: String,
        },
        resource: {
            type: String,
        },
        required: {
            type: Boolean,
        },
        nameSpace: {
            type: String,
        },
        rules: {},
        callOnValue: {
            type: Function,
            default: (val) => val,
        },
        counter: {
            type: Number,
        },
        transition: {
            type: Boolean,
            default: false,
        },
        suffix: {
            type: String,
            default: '',
        },
        prefix: {
            type: String,
            default: '',
        },
        watchProp: {
            type: Object,
            default() {
                return {
                    what: '',
                    when() {},
                };
            },
        },
        itemsText: {
            type: String,
        },
        itemsValue: {
            type: String,
        },
        blur: {
            type: Function,
            default() {
                // console.log('shared blur function')
            },
        },
        change: {
            type: Function,
            default() {
                // console.log('shared change funcion')
            },
        },
        forgalmiBetukod: {
            type: String,
            default: null,
        },
    },

    created() {
        if (this.resource) {
            this.fetchInputResource();
        }
        this.visibility = this.visible;
    },

    watch: {
        watched(val) {
            this.visibility = this.watchProp.when(val);
        },
    },

    methods: {
        ...mapActions([
            'updateHelp',
        ]),

        focus() {
            this.$store.commit('setMezo', this.mezo);
            this.updateHelp();
        },

        fetchInputResource() {
            this.$store.dispatch('getList', this.resource);
        },

        blurFn() {
            this.blur();
        },

        changeFn() {
            this.change();
        },
    },

    computed: {

        watched() {
            return Vue.prototype.$getNestedPropVal(this.$store.getters, this.watchProp.what.split('.'));
        },

        getPersistentHint() {
            return this.required ? 'Kötelező mező' : '';
        },

        getOptions() {
            return this.resource ? this.getOptionsByResourse : this.options;
        },

        getOptionsByResourse() {
            return this.$store.getters.lists[this.resource];
        },

        getInputType() {
            switch (this.type) {
            case 'text': return 'v-text-field';
            case 'select': return 'v-select';
            case 'checkbox': return 'v-checkbox';
            case 'autocomplete': return 'v-autocomplete';
            case 'date': return 'BnDate';
            // no default
            }
            throw new Error('BnInputField getInputType not implemented type');
        },
    },
};
</script>
<style scoped>

.bn-input-label {
    font-size: 17px;
    color: rgb(151, 151, 151);
}

.flex-class {
    /*margin-top: 10px;*/
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.forgalmi-prefix{
    display: inline-block;
    font-weight: bold;
    background: var(--v-primary-base)!important;
    color: #fff;
    padding: 0 1px 0 1px;
    margin: 50% 2px 0 0;
    line-height: 20px;
    font-size: 16px;
    width: 30px;
}

</style>
